import React from 'react';
import { motion } from 'framer-motion';
export function TimelineSection() {
  const weeks = [{
    week: 'Semana 1',
    title: 'Neutralización y Reset',
    desc: 'Resetear tu ciclo de sueño, eliminar la ansiedad matutina y recuperar energía real desde el primer día.'
  }, {
    week: 'Semana 2',
    title: 'Blindaje Digital y Límites',
    desc: 'Aprender a poner límites al WhatsApp y al mail laboral sin que tu jefe piense que eres irresponsable. Con base legal chilena.'
  }, {
    week: 'Semana 3',
    title: 'Fortaleza Mental Permanente',
    desc: 'Blindar tu mente para que el caos externo, el jefe difícil y el taco interminable ya no te afecten emocionalmente.'
  }];
  return <section className="py-24 bg-navy-50" data-id="element-219">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-222">
            Lo que vas a lograr en 21 días
          </h2>
          <div className="w-24 h-1 bg-orange mx-auto rounded-full" data-id="element-223"></div>
        </div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-transparent before:via-orange/30 before:to-transparent" data-id="element-224">
          {weeks.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-225">
              {/* Icon / Marker */}
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-orange text-white font-bold shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-226">
                {index + 1}
              </div>

              {/* Card */}
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:-translate-y-1" data-id="element-227">
                <div className="text-orange font-bold text-sm uppercase tracking-wider mb-2" data-id="element-228">
                  {item.week}
                </div>
                <h3 className="font-heading text-xl font-bold text-navy mb-3" data-id="element-229">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-230">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}